import {
  lookupAgencySetting,
  lookupGlobalSetting,
  resolveSetting,
  decideInitialSnapshot
} from '../model/settings-lookup'

/**
 * Exposes the pure settings-lookup helpers to the provider shell. The provider
 * component must not value-import `model/` directly (the MVVM internal-import
 * rule); this composable is the blessed indirection per the Vue MVVM contract.
 */
export function useSettingsLookup() {
  return {
    /** Resolve an agency-scoped setting, falling back to `defaultValue`. */
    lookupAgencySetting,
    /** Resolve a global-scoped setting, falling back to `defaultValue`. */
    lookupGlobalSetting,
    /** Decide a setting's scope and resolve it (returns the decision as data). */
    resolveSetting,
    /** Decide the next settings snapshot for an initialization context. */
    decideInitialSnapshot
  }
}
